import { DateString } from '@fourthwall/components';
import React from 'react';
import * as S from './DateCell.styled';
export const DateCell = ({ date }) => {
    return (React.createElement(S.Container, null,
        React.createElement(DateString, { date: date, format: "MMM D, YYYY" }),
        React.createElement(DateString, { date: date, format: "h:mma" })));
};
